import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../assets/icons/back.svg";

interface IProps {
  pageTitle: string;
  pageDescription: string;
  showBackButton?: boolean;
  sideComponent?: React.ReactNode;
}

const SectionHeader = ({
  pageTitle,
  pageDescription,
  showBackButton = false,
  sideComponent,
}: IProps) => {
  const navigate = useNavigate();
  return (
    <div className="content-header flex justify-between ">
      <div className="main-deatils">
        <h1 className="flex items-center" data-cy="pageTitle">
          {showBackButton ? (
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="back-button mr-3"
              title="Go Back"
              data-cy="goBack"
            >
              <BackIcon />
            </button>
          ) : null}
          {pageTitle}
        </h1>
        <p data-cy="pageDescription">{pageDescription}</p>
      </div>

      {sideComponent !== undefined ? sideComponent : null}
    </div>
  );
};
export default SectionHeader;
